import styled, { Spacing, Font, Color, Breakpoint } from '@nfinite/react-hubstairs/styled'

import CollapseComponent from 'components/Commons/Collapse'

export const GridContainer = styled('div')`
  width: 100%;
  display: grid;
  align-items: center;
  justify-items: flex-start;
  color: ${Color.get('text')};
  ${Font.generate({ size: 's' })}

  ${Spacing.generatePadding({ vertical: 'xs', horizontal: 'xs' })}
  grid-column-gap: ${Spacing.get('xs')}px;

  grid-template-columns: ${({ template }) => template};
  grid-template-rows: ${({ extraRows, rowHeight = 40 }) =>
    !extraRows ? `${rowHeight}px` : `${rowHeight}px repeat(${extraRows}, auto)`};

  ${Breakpoint.greaterThanMobile()} {
    grid-gap: ${Spacing.get('m')}px;
    ${Spacing.generatePadding({ horizontal: 'm' })}
  }
`

export const ToggleCollapse = styled('div')`
  width: 6px;
  height: 4px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  ${({ open }) => open && `transform: rotate(90deg);`}
`

ToggleCollapse.Wrapper = styled('div')`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`

ToggleCollapse.Dash = styled('div')`
  width: 100%;
  height: 1px;
  background-color: ${Color.get('background', 'contrast')};
`

export const Collapse = styled(CollapseComponent)`
  grid-column: 1 / span 4;
  width: 100%;
`

export const CollapseContent = styled('div')`
  ${Spacing.generatePadding({ top: 'xs' })}
  display: flex;
  flex-direction: column;
`

export const CollapseItem = styled('div')`
  width: 100%;
  ${Spacing.generateMargin({ bottom: 's' })}
`

CollapseItem.Label = styled('p')`
  ${Spacing.generateMargin({ top: '0', bottom: 'xs' })}
  color: ${Color.get('text', 'gray')};
`
